import React from 'react';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';

function ExportExcel(props) {
  const { filename, companiesDataSet } = props;

  const [data, setData] = React.useState({});

  const exporter = React.useRef();

  const exportExcelFunction = () => {
    if (exporter.current) {
      exporter.current.save();
    }
  };

  React.useEffect(() => {
    const temp = (companiesDataSet || []).reduce((acc, element) => {
      const data = { ...element };
      data.active = element.active ? 'Activa' : 'En espera';
      acc.push(data);
      return acc;
    }, []);
    setData(temp);
  }, [companiesDataSet]);

  return (
    <>
      <button type="button" className="k-button k-primary" onClick={exportExcelFunction}>
        Exportar a Excel
      </button>
      <ExcelExport data={data} fileName={`${filename}.xlsx`} ref={exporter}>
        <ExcelExportColumn title="Estatus" field="active" />
        <ExcelExportColumn title="Nombre" field="companyName" />
        <ExcelExportColumn title="Nombre del administrador" field="adminName" />
        <ExcelExportColumn title="Correo electrónico" field="adminName" />
        <ExcelExportColumn title="Página web" field="companyWebsite" />
        <ExcelExportColumn title="Campus / Sede asociado" field="campusSegment" />
        <ExcelExportColumn title="CV" field="cv" />
        <ExcelExportColumn title="RFC" field="companyRFC" />
        <ExcelExportColumn title="Comprobante de domicilio" field="companyAddressProof" />
        <ExcelExportColumn title="Teléfono" field="companyPhone" />
        <ExcelExportColumn title="Ubicación" field="locationName" />
        <ExcelExportColumn title="Giro" field="companyLine" />
        <ExcelExportColumn title="Número de empleados" field="companyEmployeesNumber" />
        <ExcelExportColumn title="Descripción" field="data" />
      </ExcelExport>
    </>
  );
}

export default ExportExcel;
